import { render, staticRenderFns } from "./gambarModal.vue?vue&type=template&id=bf057ff6&scoped=true&"
import script from "./gambarModal.vue?vue&type=script&lang=js&"
export * from "./gambarModal.vue?vue&type=script&lang=js&"
import style0 from "./gambarModal.vue?vue&type=style&index=0&id=bf057ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf057ff6",
  null
  
)

export default component.exports